const therapistScope = "therapist";

export default {
  successfullyBookedAppointment: `${therapistScope}.successfullyBookedAppointment`,
  referToFriend: `${therapistScope}.referToFriend`,
  aboutMe: `${therapistScope}.aboutMe`,
  purchaseCredits: `${therapistScope}.purchaseCredits`,
};
